import React, { Component } from "react";
import AuthService from "../services/auth.service";
import DataService from "../services/data.service";
import MySystemsForm from "./mySystemsForm.component";

export default class BoardUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: [],
      clusters: [],
      logg: [],
      userIsModerator: false,
    };

    this.staticInterval = null;
    this.loggInterval = null;
  }

  componentDidMount() {
    this.initData();

    // 🔁 Sjeldent fallback (hvis fanen står åpen lenge)
    this.staticInterval = setInterval(this.pollStaticIfVisible, 60000); // 1 min
    this.loggInterval = setInterval(this.pollLoggIfVisible, 120000); // 2 min

    document.addEventListener("visibilitychange", this.handleVisibility);
  }

  componentWillUnmount() {
    clearInterval(this.staticInterval);
    clearInterval(this.loggInterval);
    document.removeEventListener("visibilitychange", this.handleVisibility);
  }

  /* ======================
     VISIBILITY
     ====================== */

  handleVisibility = () => {
    if (!document.hidden) {
      // 🔄 Når bruker kommer tilbake → hent ferske data
      this.pollStatic();
      this.pollLogg();
    }
  };

  pollStaticIfVisible = () => {
    if (!document.hidden) {
      this.pollStatic();
    }
  };

  pollLoggIfVisible = () => {
    if (!document.hidden) {
      this.pollLogg();
    }
  };

  /* ======================
     DATA
     ====================== */

  initData = async () => {
    await this.pollStatic();
    await this.pollLogg();
  };

  pollStatic = async () => {
    const user = AuthService.getCurrentUser();
    if (!user) {
      this.resetState();
      return;
    }

    try {
      const [contentRes, clustersRes] = await Promise.all([
        DataService.getBasicSystems(user.id),
        DataService.getClusters(user.id),
      ]);

      this.setState({
        content: contentRes.data,
        clusters: clustersRes.data,
        userIsModerator:
          user.roles.includes("ROLE_MODERATOR") ||
          user.roles.includes("ROLE_ADMIN"),
      });
    } catch (error) {
      console.error("Feil ved henting av static data:", error);
      this.resetState();
    }
  };

  pollLogg = async () => {
    const user = AuthService.getCurrentUser();
    if (!user) return;

    try {
      const loggRes = await DataService.getLogg(user.id);
      this.setState({ logg: loggRes.data });
    } catch (error) {
      console.error("Feil ved henting av logg:", error);
    }
  };

  resetState = () => {
    this.setState({
      content: [],
      clusters: [],
      logg: [],
      userIsModerator: false,
    });
  };

  /* ======================
     OPTIMISTISK OPPDATERING
     ====================== */

  updateLoggActive = (id, active) => {
    this.setState((prevState) => ({
      logg: prevState.logg.map((row) =>
        row.id === id ? { ...row, active } : row
      ),
    }));
  };

  /* ======================
     RENDER
     ====================== */

  render() {
    const { content, clusters, logg, userIsModerator } = this.state;

    return (
      <div className="grid_container">
        {content && content.length > 0 ? (
          <MySystemsForm
            myContent={content}
            myClusters={clusters}
            myLogg={logg}
            userIsModerator={userIsModerator}
            onUpdateLoggActive={this.updateLoggActive}
            onLoggUpdated={this.handleVisibility} 
          />
        ) : (
          <span className="viewcard21">
            <h3>No Access, please login again.</h3>
          </span>
        )}
      </div>
    );
  }
}
